/**
 * Checkout extras: require terms checkbox before place-order can be pressed.
 */
(function () {
    function isCheckout() {
        return !!document.querySelector(
            '.wp-block-woocommerce-checkout, .wc-block-checkout, body.woocommerce-checkout'
        );
    }

    function findTermsCheckbox(root) {
        const scope = root || document;
        return (
            scope.querySelector('.wc-block-checkout__terms input[type="checkbox"]') ||
            scope.querySelector('.wc-block-components-checkbox.wc-block-checkout__terms input') ||
            scope.querySelector('[class*="checkout-terms"] input[type="checkbox"]') ||
            null
        );
    }

    function findPlaceOrderButtons(root) {
        const scope = root || document;
        return Array.from(
            scope.querySelectorAll(
                '.wc-block-components-checkout-place-order-button, button.wc-block-components-checkout-place-order-button'
            )
        );
    }

    function syncPlaceOrderState() {
        if (!isCheckout()) {
            return;
        }

        const checkbox = findTermsCheckbox();
        const buttons = findPlaceOrderButtons();
        if (!buttons.length) {
            return;
        }

        // If WC already renders a terms checkbox, gate the CTA on it.
        // If somehow missing, inject one above the button.
        let box = checkbox;
        if (!box) {
            box = ensureInjectedTerms();
        }

        const allowed = !!(box && box.checked);
        buttons.forEach((btn) => {
            btn.disabled = !allowed;
            btn.setAttribute('aria-disabled', allowed ? 'false' : 'true');
            btn.classList.toggle('is-disabled', !allowed);
            if (!allowed) {
                btn.setAttribute('tabindex', '-1');
            } else {
                btn.removeAttribute('tabindex');
            }
        });
    }

    function ensureInjectedTerms() {
        const existing = document.querySelector('[data-rocket-terms-check]');
        if (existing) {
            return existing.querySelector('input[type="checkbox"]');
        }

        const submit =
            document.querySelector('.wc-block-checkout__actions') ||
            document.querySelector('.wc-block-components-checkout-place-order-button')?.parentElement;

        if (!submit) {
            return null;
        }

        const wrap = document.createElement('label');
        wrap.className = 'wc-block-components-checkbox rocket-checkout-terms';
        wrap.setAttribute('data-rocket-terms-check', '1');
        wrap.innerHTML =
            '<input class="wc-block-components-checkbox__input" type="checkbox" />' +
            '<span class="wc-block-components-checkbox__label">Tęsdami pirkimą sutinku su taisyklėmis ir sąlygomis bei privatumo politika</span>';

        submit.parentElement
            ? submit.parentElement.insertBefore(wrap, submit)
            : submit.prepend(wrap);

        const input = wrap.querySelector('input');
        input.addEventListener('change', syncPlaceOrderState);
        return input;
    }

    function bind() {
        syncPlaceOrderState();

        document.addEventListener(
            'click',
            (event) => {
                const btn = event.target.closest(
                    '.wc-block-components-checkout-place-order-button'
                );
                if (!btn) {
                    return;
                }
                const checkbox = findTermsCheckbox() || document.querySelector('[data-rocket-terms-check] input');
                if (checkbox && !checkbox.checked) {
                    event.preventDefault();
                    event.stopPropagation();
                    checkbox.focus();
                }
            },
            true
        );

        document.addEventListener('change', (event) => {
            if (event.target && event.target.matches('input[type="checkbox"]')) {
                syncPlaceOrderState();
            }
        });

        if (window.MutationObserver) {
            let timer = null;
            new MutationObserver(() => {
                clearTimeout(timer);
                timer = setTimeout(syncPlaceOrderState, 60);
            }).observe(document.body, { childList: true, subtree: true });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
    } else {
        bind();
    }
})();
